import type { FieldDefinition, Schema } from "./types";

/**
 * Секрет-заглушка для заблокированных password-полей: реальный секрет
 * наружу не отдаётся, но поле должно выглядеть заполненным, а не пустым.
 */
export const SECRET_PLACEHOLDER = "••••••••";

/**
 * Копия схемы, где каждое поле заблокировано. Нужна карточкам подключений
 * (Stripe, Paynet, CCBill, Cloudflare, Bunny): пока интеграция подключена,
 * поля только показывают сохранённые значения, менять их можно после
 * «Отключить» или «Заменить». Проп `disabled` у FormBuilder до полей не
 * доходит (он гасит только кнопки), поэтому блокируем через disabledCheck.
 */
export function lockSchema(schema: Schema): Schema {
  return Object.fromEntries(
    Object.entries(schema).map(([name, field]) => {
      if (name === "tabs" || !field || !("type" in field)) {
        return [name, field];
      }
      const locked: FieldDefinition = {
        ...(field as FieldDefinition),
        disabledCheck: () => true,
      };
      return [name, locked];
    })
  ) as Schema;
}
